
function getInitialName(name) {
    let initials;
    const nameSplit = name.split(" ");
    const nameLength = nameSplit.length;
    if (nameLength > 1) {
        initials =
            nameSplit[0].substring(0, 1) +
            nameSplit[nameLength - 1].substring(0, 1);
    } else if (nameLength === 1) {
        initials = nameSplit[0].substring(0, 1);
    } else return;
    return initials.toUpperCase();
};
function createImageFromInitials(name, size = 500, color = getRandomColor()) {
    if (name == null) return;
    name = getInitialName(name)
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    canvas.width = canvas.height = size
    context.fillStyle = "#ffffff"
    context.fillRect(0, 0, size, size)
    context.fillStyle = `${color}50`
    context.fillRect(0, 0, size, size)
    context.fillStyle = color;
    context.textBaseline = 'middle'
    context.textAlign = 'center'
    context.font = `${size / 2}px Roboto`
    context.fillText(name, (size / 2), (size / 2))
    return canvas.toDataURL()
};
function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
function convertBase64(file) {
    return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
            resolve(fileReader.result);
        };
        fileReader.onerror = (error) => {
            reject(error);
        };
    });
};

function getFilteredQuery(filter) {
  if (!filter) {
    return "";
  }
  const query = Object.keys(filter)
    .filter(key => filter[key] !== null && filter[key] !== undefined && filter[key] !== '')
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(filter[key])}`)
    .join('&');
  return query;
}

function capitalizeFirstLetter(string) {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1);
}

const isImageFile = (file) => {
  if (!file) return false;

  // If it's a File/Blob object
  if (file instanceof File || file instanceof Blob) {
    return file.type.startsWith("image/");
  }

  // If it's a string (e.g., mime type or file path)
  if (typeof file === "string") {
    return file.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/) !== null;
  }

  return false;
};
export {
    getFilteredQuery,
    isImageFile,
    createImageFromInitials,
    getRandomColor,
    convertBase64,
    capitalizeFirstLetter
}